export enum FrameConnectionType {
  Diagonal = 'diagonal',
  Side = 'side',
  Vertical = 'vertical',
}
